import React from 'react';

interface LiveIndicatorProps {
  className?: string;
  showText?: boolean;
  isStreaming?: boolean;
}

const LiveIndicator: React.FC<LiveIndicatorProps> = ({ 
  className = "", 
  showText = true,
  isStreaming = false
}) => {
  // Only show if actually streaming
  if (!isStreaming) {
    return (
      <div className={`flex items-center ${className}`}>
        <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
        {showText && (
          <span className="ml-2 text-xs text-gray-500 font-medium">
            POLLING
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
        <div className="absolute inset-0 w-2 h-2 bg-green-500 rounded-full animate-ping opacity-75"></div>
      </div>
      {showText && (
        <span className="ml-2 text-xs text-green-600 font-medium">
          LIVE STREAM
        </span>
      )}
    </div>
  );
};

export default LiveIndicator;
